import { type ToastOptions, toast } from 'react-hot-toast'

import { Icon, type IconName } from '../icon/icon.tsx'
import { ToastItem, type ToastItemProps } from './toast-item.tsx'

const ToastIcon = ({ name }: { name: IconName }) => (
  <Icon name={name} size="lg" />
)

type ShowToastProps = Omit<ToastItemProps, 'message'>
type ShowThemedToastProps = Omit<ShowToastProps, 'icon'>

type Message = { id: string }

export const showToast = Object.assign(
  (props: ShowToastProps, options: ToastOptions = {}) => {
    toast(
      (message: Message) => <ToastItem message={message} {...props} />,
      options
    )
  },
  {
    success: (props: ShowThemedToastProps, options: ToastOptions = {}) => {
      toast(
        (message: Message) => (
          <ToastItem
            message={message}
            icon={<ToastIcon name="SuccessIcon" />}
            {...props}
          />
        ),
        options
      )
    },

    error: (props: ShowThemedToastProps, options: ToastOptions = {}) => {
      toast(
        (message: Message) => (
          <ToastItem
            message={message}
            icon={<ToastIcon name="ErrorIcon" />}
            {...props}
          />
        ),
        options
      )
    },

    warning: (props: ShowThemedToastProps, options: ToastOptions = {}) => {
      toast(
        (message: Message) => (
          <ToastItem
            message={message}
            icon={<ToastIcon name="WarningIcon" />}
            {...props}
          />
        ),
        options
      )
    },

    info: (props: ShowThemedToastProps, options: ToastOptions = {}) => {
      toast(
        (message: Message) => (
          <ToastItem
            message={message}
            icon={<ToastIcon name="information" />}
            {...props}
          />
        ),
        options
      )
    },
  }
)
